import {
  ADAnalyzeIndicator,
  ADChartIndicator,
  OptionalFilterKey,
} from '@/types/marketing';

/*
 * OMS 백엔드 <-> 포탈 백엔드 <-> 포탈 프론트
 * [OMS-API](https://ec-oms-ad-internal-api.dev.fnf.co.kr)
 */
const baseURL = '/proxy/oms-ad-internal' + '/api';

export default {
  /**
   * @GET (CTR|ROAS) 지표의 상하위 목록을 조회
   */
  AD_TOP_LOW_DATA: (indicator: ADChartIndicator) =>
    `${baseURL}/v1/ad/top-low/${indicator}`,
  /**
   * @GET (CTR|ROAS) 지표의 상하위 목록을 AI를 통해 비교 요청
   */
  AD_TOP_LOW_ANALYZE: (indicator: ADAnalyzeIndicator) =>
    `${baseURL}/v1/ad/top-low/analyze/${indicator}`,
  /**
   * @GET AI를 통해 비교 요청한 결과를 조회
   */
  AD_TOP_LOW_ANALYZE_DATA: (aiPipelineId: string) =>
    `${baseURL}/v1/ad/top-low/analyze/${aiPipelineId}`,
  /**
   * @GET 광고 소재 기간별 추이 조회
   */
  AD_TREND: `${baseURL}/v1/ad/trend`,
  /**
   * @GET 광고 소재 기간별 목록 조회
   */
  AD_LIST: baseURL + '/v1/ad/performances',
  /**
   * @GET 광고 소재 기간별 목록 엑셀 다운로드
   */
  AD_LIST_EXCEL: baseURL + '/v1/ad/performances/excel',
  /**
   * @GET 광고 소재 필터 값 조회
   */
  AD_FILTER_VALUES: (filterKey: OptionalFilterKey | 'brands') =>
    `${baseURL}/filters/${filterKey}`,
  /**
   * @GET 광고 소재의 상세 정보와 기간별 취합 정보를 조회
   */
  AD_DETAIL: (adMasterId: string) =>
    `${baseURL}/v1/ad/performances/${adMasterId}`,
  /**
   * @POST 광고 소재 코멘트 개수 증감
   */
  AD_DETAIL_COMMENT_COUNT: (adMasterId: string, isIncrement: boolean) =>
    `${baseURL}/v1/ad/performances/${adMasterId}/comments/${
      isIncrement ? 'increment' : 'decrement'
    }`,
};
